import { multiFactor, User } from "firebase/auth";

export const checkMFAStatus = (user: User | null): boolean => {
  if (!user) return false;

  const factors = multiFactor(user).enrolledFactors;
  return factors.length > 0;
};
